import { render } from "./VendorIcon.vue?vue&type=template&id=4b1dc2be"
import script from "./VendorIcon.vue?vue&type=script&lang=js"
export * from "./VendorIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__